/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Anton Kalachev <anton.kalachev@opensoftdev.com>
 */

import 'APP_THEME/_common/vip_level_tooltip/vip_level_tooltip.less';

import SelfClosedPopup from 'assets/js/modules/popup/SelfClosedPopup';
import Popup from 'assets/js/modules/popup/PopupLight';
import storage from 'assets/js/common/storage/permanent';
import screen from 'assets/js/modules/screen';

export default class {
    constructor() {
        this.vipTooltip = new SelfClosedPopup(new Popup($('#vip-tooltip:not(.mobile)'), { width: 400 }));
    }
    open() {
        const vipTooltipMessageViewed = 'vip_tooltip_message_viewed';
        const storageInstance = storage.getInstance();
        if (ONP.user.loggedIn && !screen.isXs()) {
            if (!storageInstance.getItem(vipTooltipMessageViewed)) {
                this.vipTooltip.open(10000);
                storageInstance.setItem(vipTooltipMessageViewed, true);
            }
        } else {
            storageInstance.removeItem(vipTooltipMessageViewed);
        }
    }
}
